import React, {useEffect} from 'react';
import {Card, CardBody, CardTitle} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import {connect, useSelector} from 'react-redux'

// components
import {confirmAlert} from 'react-confirm-alert';
import {GenericTableButton, } from "../../../components/buttons/buttonsActions";
import TranslateButton from "../../../components/buttons/TranslateButton";
import {ActiveFormatter} from "../../../components/tables/activeFormater";
import {ConfirmDelete} from "../../../components/confirmAlert/ConfirmDelete";
import {ConfirmAssignPriceForm} from "../../../components/confirmAlertForms/ConfirmAssignPriceForm";
import {ConfirmAssignTreatmentPriceForm} from "../../../components/confirmAlertForms/ConfirmAssignTreatmentPriceForm";
import {ModalFormContainer} from "../../../components/confirmAlert/ModalFormContainer";
import DishDrinkForm from "./_form";

// labels
import {TT_DELETE, TT_EDIT, TT_UPD_PRICES} from "../../../components/i18n/toolTips";
import {LIST, NO_DATA_FOUND,} from "../../../components/i18n/i18n";

// actions

// services
import {dishDrinkService} from "../../../jwt/_services/ayb/dishDrinkService";
import {getStateByPath} from "../../../redux/selectors";
import {genericIndexedActions} from "../../../redux/actions/generics/GenericIndexedActions";
import paginationFactory from "react-bootstrap-table2-paginator";
import {GenericButton} from "../../../components/buttons/customButtons";
import DishDrinkFilters from "./_filters";
import {setFilter, setForm, setItem, setTableParams} from "../../../redux/actions/generics/IndexedActions";



const DishDrinkList = props => {
    const path = props?.path ;
    const componentState = useSelector(state => getStateByPath(state, path));
    const {app, udn, category, pageSize, pageIndex, totalSize, listDomainObjects, filter} = componentState?.data || {};

    useEffect( () => {
        if( !app.id || !udn.id || filter  )
            return

        props.setFilter(path, {
            onlyRegistered: true,
            fbDataBase : { id : app?.fbDataBase?.id },
            item :  {
                udn : { id : udn.id }
            }
        })
    }, [ app, udn ]);

    useEffect(() => {
        if(!filter)
            return

        genericIndexedActions.search(path, dishDrinkService, pageIndex, pageSize, filter)
    }, [pageIndex, pageSize, filter]);

    const handleTableChange = (type, {page, sizePerPage}) => {
        let currentIndex = (page - 1) * sizePerPage
        props.setTableParams(path, sizePerPage, currentIndex, totalSize, currentIndex )
    };


    const editItem = data => {
        props.setItem(path, data);
        props.setForm(path, true, false, false);

        ModalFormContainer(DishDrinkForm, { path, data, closeOnEscape:false,
            closeOnClickOutside: false})
    }

    const createItem = () => {
        props.setItem(path, null);
        props.setForm(path)

        ModalFormContainer(DishDrinkForm, { path })
    }


    const confirmDelete = data => ConfirmDelete({
        path,
        data,
        fbDataBaseId: app?.fbDataBase?.id,
        service: dishDrinkService,
        remove : genericIndexedActions.delete,
    } );

    const confirmAssignPrice = item => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside:true,
        customUI: ({onClose}) => <ConfirmAssignPriceForm item={item} fbDataBaseId={app?.fbDataBase?.id} onClose={onClose} />
    });

    const ConfirmAssignTreatmentPrice = item => confirmAlert({
        closeOnEscape: true,
        closeOnClickOutside:true,
        customUI: ({onClose}) => <ConfirmAssignTreatmentPriceForm item={item} fbDataBaseId={app?.fbDataBase?.id} onClose={onClose}  durationOptions={item.durationOptions}/>
    });

    const activeFormatter = (cell) => <ActiveFormatter active={cell}/>


    const actionsFormatter = (cell, row) => <>
                <GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
                <TranslateButton item={row} service={dishDrinkService} />
                {
                    (category === 'REST' || category === 'HCDP_CUISINE;HCDP_BAR;HCDP_INSIDE_HOUSE') ? <GenericTableButton toolTip={TT_UPD_PRICES} icon={'fa fa-money'} permission={'prices'} onClick={() => confirmAssignPrice(row)}/> :
                        (category === 'XPA' || category === 'HCDP_SPA') ? <GenericTableButton toolTip={TT_UPD_PRICES} icon={'fa fa-money'} permission={'prices'} onClick={() => ConfirmAssignTreatmentPrice(row)}/> : null
                }
                <GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
            </>

    const columns = [
        {
            dataField: 'id',
            headerStyle: {width: '0px'},
            text: 'ID',
            hidden: true
        }, {
            dataField: 'uid',
            text: 'uid',
            headerStyle: {width: '200px'},
        }, {
            dataField: 'title',
            text: 'Titulo'
        }, {
            dataField: 'categoryName',
            text: 'Categoría',
            headerStyle: {width: '150px'},
        }, {
            dataField: 'subCategoryName',
            text: 'Sub-categoría',
            headerStyle: {width: '150px'},
        }, {
            dataField: 'showOrder',
            text: 'Orden',
            headerStyle: {width: '80px'},
        }, {
            dataField: 'status',
            text: "Activo",
            headerStyle: {width: '80px'},
            formatter: activeFormatter
        }, {
            dataField: 'actions',
            isDummyField: true,
            text: 'Acción',
            headerAlign: 'center',
            align:'center',
            headerStyle: {width: '260px'},
            formatter: actionsFormatter
        }
    ];

    return ( <Card>

        <CardTitle className="bg-light border-bottom p-3 mb-0">
            <i className="far fa-list-alt mr-2"/>{LIST}
            <div className="float-right">
                {
                    (category === 'XPA' || category === 'HCDP_SPA') ?
                        <GenericButton
                            style={'warning-secondary'}
                            label={'Actualizar precios'}
                            toolTip={'Elige el tipo de cambio para actualizar los precios'}
                            icon={'fa-sync'}
                            permission={'edit'}
                            onClick={confirmAssignPrice}
                        /> : null
                }
                <GenericButton
                    style={'table'}
                    label={'Agregar'}
                    toolTip={'Agregar'}
                    icon={'fa-plus'}
                    permission={'add'}
                    onClick={createItem}
                />
            </div>
        </CardTitle>
        <DishDrinkFilters path={path}/>
        <CardBody>
            <BootstrapTable
                striped hover
                tableHeaderClass='mb-0'
                remote
                keyField="id"
                data={listDomainObjects || []}
                columns={ columns }
                noDataIndication={NO_DATA_FOUND}
                pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                onTableChange={ handleTableChange }
            />
        </CardBody>
    </Card> )
}

const mapStateToProps = state => ({
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setItem,
    setForm,
})

export default connect(mapStateToProps, mapActionsToProps)(DishDrinkList)